<div class="app-data-table__wrapper">
  <table class="app-data-table">
    <thead>
      <tr>
        <th *ngFor="let column of columns; trackBy: trackByIndex">
          {{ column.label }}
        </th>
      </tr>
    </thead>

    <tbody>
      <tr
        *ngFor="let row of rows; trackBy: trackByIndex"
        class="app-data-table__row"
        [class.app-data-table__row--clickable]="clickableRows"
        (click)="onRowClick(row)"
      >
        <td *ngFor="let column of columns; trackBy: trackByIndex">
          {{ row[column.key] }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="app-data-table__pagination" *ngIf="totalPages > 1">
  <button
    type="button"
    class="app-data-table__nav"
    [disabled]="page === 1"
    (click)="goToPage(page - 1)"
  >
    Anterior
  </button>

  <span class="app-data-table__page">
    {{ page }} de {{ totalPages }}
  </span>

  <button
    type="button"
    class="app-data-table__nav"
    [disabled]="page === totalPages"
    (click)="goToPage(page + 1)"
  >
    Próximo
  </button>
</div>